export const dealerIndicator = {
  "dealerindicator.metrics.get": "dealerindicator.metrics.get",
} as const;
